import { getWsEndpoint } from "@utils/get-ws-endpoint";

export type ENV = "mainnet-beta" | "testnet" | "devnet" | "localnet";

const nftEndpointDevnet = "https://mnde-nft-api.devnet.marinade.finance/";
const dsEndpointDevnet = "https://validators-api-dev.marinade.finance/";
const coinbasePayAppId = "a7342146-3731-4a1e-b9fb-5ff7360b3174";
const webConfigPrefix =
  "https://raw.githubusercontent.com/marinade-finance/marinade-web-config/main/validators/";

export const ENDPOINTS = [
  {
    name: "devnet" as ENV,
    endpoint: process.env.NEXT_PUBLIC_DEV_ENDPOINT ?? "",
    nftEndpoint: nftEndpointDevnet,
    dsEndpoint: dsEndpointDevnet,
    scoringEndpoint: "https://scoring-dev.marinade.finance/api/v1",
    wsEndpoint: getWsEndpoint(process.env.NEXT_PUBLIC_DEV_ENDPOINT ?? ""),
    referralEndpoint: "https://native-staking-referral-dev.marinade.finance/",
    dialectKey: "Gd32rYhyzpmrcaPxitTPAkiXsyx1BPyUbzYjz3XEthuo",
    dialectEnv: "devnet",
    coinbasePayAppId,
    webConfig: `${webConfigPrefix}devnet.json`,
  },
  {
    name: "mainnet-beta" as ENV,
    endpoint: process.env.NEXT_PUBLIC_MAIN_ENDPOINT ?? "",
    nftEndpoint: "https://mnde-nft-api.mainnet-beta.marinade.finance/",
    dsEndpoint: "https://validators-api.marinade.finance/",
    scoringEndpoint: "https://scoring.marinade.finance/api/v1",
    wsEndpoint: getWsEndpoint(process.env.NEXT_PUBLIC_MAIN_ENDPOINT ?? ""),
    referralEndpoint: "https://native-staking-referral.marinade.finance/",
    dialectKey: "FfHsDc36mMT6XRuQwCbBKbKt1Bk9Nfqf9trUN9GmpuX3",
    dialectEnv: "mainnet",
    coinbasePayAppId,
    webConfig: `${webConfigPrefix}mainnet.json`,
  },
];

export const DEFAULT_ENDPOINT =
  ENDPOINTS[Number(process.env.NEXT_PUBLIC_NETWORK) ?? 0];
